
export default function frameWidth(){
    return document.getElementById('certificate-frame')?.clientWidth || 300;
}

export function frameHeight(){
    return document.getElementById('certificate-frame')?.clientHeight || 300;
}

export function percentX(x){

    const width = frameWidth();

    return x / width * 100;
}

export function percentY(y){

    const height = frameHeight();

    return y / height * 100;
}

export function isContained(childId) {

    const child = document.getElementById(childId);
    const parent = document.getElementById('certificate-frame');

    const childRect = child.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    return childRect.top >= parentRect.top &&
           childRect.left >= parentRect.left &&
           childRect.bottom <= parentRect.bottom &&
           childRect.right <= parentRect.right;
}

